import { api } from "./client";

export interface TwoFAStatus {
  enabled: boolean;
  backup_codes_remaining: number;
}

export interface SetupResult {
  secret: string;
  qr_data_url: string;
  enabled: boolean;
}

export interface EnableResult {
  enabled: boolean;
  backup_codes: string[];
}

export async function fetchStatus(): Promise<TwoFAStatus> {
  const r = await api.get<TwoFAStatus>("/auth/2fa/status");
  return r.data;
}

export async function setup2FA(): Promise<SetupResult> {
  const r = await api.post<SetupResult>("/auth/2fa/setup");
  return r.data;
}

export async function verify2FA(code: string): Promise<EnableResult> {
  const r = await api.post<EnableResult>("/auth/2fa/verify", { code });
  return r.data;
}

export async function disable2FA(code: string): Promise<void> {
  await api.post("/auth/2fa/disable", { code });
}

export async function regenerateBackup(code: string): Promise<EnableResult> {
  const r = await api.post<EnableResult>("/auth/2fa/regenerate-backup-codes", { code });
  return r.data;
}

export interface OTPStepIn {
  otp_token: string;
  code: string;
}

export interface TokenOut {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export async function loginOtpStep(input: OTPStepIn): Promise<TokenOut> {
  // axios 가 아닌 fresh — login otp step 은 access token 없는 상태
  const r = await api.post<TokenOut>("/auth/login/otp", input);
  return r.data;
}
